import { InjectionToken, Provider } from '@angular/core';

/**
 * Tenant-API config — only the base URL today, but kept as a struct so we can
 * grow it (e.g. timeouts, retry policy) without changing the provider call
 * sites in `app.config.ts`.
 */
export interface TenantApiConfig {
  readonly baseUrl: string;
}

export const TENANT_API_CONFIG = new InjectionToken<TenantApiConfig>('TENANT_API_CONFIG');

export function provideTenantApiConfig(config: TenantApiConfig): Provider {
  return { provide: TENANT_API_CONFIG, useValue: config };
}
